import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
    selector: "[appPasswordToggle]",
})
export class PasswordToggleDirective {
    @Input() targetInput: any;
    @Input() buttonIcon: any;

    @HostListener("click", ['$event.target']) onClick(ev) {
        console.log('ué', ev)
        const inType =
            this.targetInput.el.type === "text" ? "password" : "text";
        this.targetInput.el.type = inType;

        const iconName =
            this.buttonIcon.el.name === "eye-outline"
                ? "eye-off-outline"
                : "eye-outline";
        this.buttonIcon.el.name = iconName;
    }
}
